export default __webpack_public_path__ + "static/media/iso_27001-150x150 1.a22827b7.png";